/**
 * Route for `ab-testing-creatives-landing-pages`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AbTestingCreativesLandingPagesPage } from "../features/ab-testing-creatives-landing-pages/AbTestingCreativesLandingPagesPage";

export const abTestingCreativesLandingPagesRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/ab-testing-creatives-landing-pages",
	component: AbTestingCreativesLandingPagesPage,
});

export default abTestingCreativesLandingPagesRoute;
